import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";

import Section from "../../../common/components/layout/utils/Section";
import RenderArticleWithFadeEffect from "../../../common/components/rich-text-renderer/RenderArticleWithFadeEffect";
import authService from "../../../common/service/authService";
import CourseInstructors from "./CourseInstructors";

const About: React.FC<NSCourses.IAboutProps> = ({
  about,
  courseInstructors,
}) => {
  const theme = useTheme();

  return (
    <Section boxProps={{ py: { xs: 6, md: 12 } }}>
      <Grid container>
        <Grid item xs={12} md={6} sx={{}}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              pb: { xs: 2, md: 4 },
              [theme.breakpoints.down("sm")]: { fontSize: 18 },
            }}
          >
            About this course
          </Typography>
          <RenderArticleWithFadeEffect content={about} />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            [theme.breakpoints.down("md")]: {
              my: 8,
            },
          }}
        >
          <CourseInstructors courseInstructors={courseInstructors} />
        </Grid>
      </Grid>
    </Section>
  );
};

export default About;
